<template>
  <div id="ComponentList" class="page message-list-page">
    <!-- 构件 -->
    <page-title page-name="构件" icon="iconfont icon-goujian" @module-change="moduleChange" />
    <div v-if="platformCode" class="content-container">
    <div class="content-container">
      <div class="search-line">
        <el-form class="search-form" inline :model="searchForm" @submit.native.prevent>
          <!-- 适配软件 -->
          <software-select ref="softwareSelect" :resource-type="resourceType" :sub-module="currentSubmodule" :platform="platformCode" :is-version-require="false" :is-available="availableResource" @change="changeSoftware" />
          <!-- 状态 -->
          <el-form-item label="状态">
            <el-select class="status-select" v-model="searchForm.status" placeholder="不限" :disabled="availableResource" clearable @change="()=>search()" style="width: 100px;">
              <el-option
                v-for="item in statusOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- 只看可用资源 -->
          <el-form-item v-if="clientType !== 'web' && clientTypeSoftwareCode === softwareCode">
            <el-switch
              v-model="availableResource"
              class="available-switch"
              active-color="009EE1"
              inactive-color="BFBFBF"
              active-text="只看可用资源"
              @change="changeAvailableResource">
            </el-switch>
          </el-form-item>
        </el-form>
        <div>
          <el-input
            v-model="searchForm.keyword"
            class="keyword-input"
            clearable
            placeholder="搜索名称"
            @change="()=>search()"
          >
            <i slot="append" class="el-icon-search" />
          </el-input>
        </div>
      </div>
      <div class="flex-1">
        <gjw-list-page-layout>
          <template #leftBox>
            <div class="catalog">
              <ClassifyTreeV2
              TYPE="COMPONENT"
              ref="classifyTree"
              :tree-data="classifyData.tree"
              :list-data.sync="classifyData.list"
              :draggable="true"
              :editable="true"
              :expanded-keys="defaultKeyArr"
              :currentSubmodule="currentSubmodule"
              @updateListData="updateListData"
              @tree-node-click="treeNodeClick"
              @node-expand="treeNodeExpand"
              @node-collapse="treeNodeCollapse"
              @handleDrop="handleDrop"
              @handleRename="handleRename"
              @handleNew="handleNew"
              @stopPolling="stopPolling"
              @startPolling="startPolling(polling)"
            />
            </div>
          </template>
          <!-- 批量操作 -->
          <template #btnBox>
            <div class="btn-left">
              <div class="operations-left">
                <el-button type="primary" icon="iconfont icon-wenjian-shangchuan" :disabled="hasPermission(activePermissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_UPLOAD': 'REVIT_COMPONENT_UPLOAD')" @click="showUploader('upload')">上传</el-button>
              </div>
              <div v-if="selectedList.length" class="batch-button-box">
                <el-button v-if="clientType === 'web'" icon="iconfont icon-wenjian-xiazai" plain @click="batchDownload">下载</el-button>
                <el-button
                    v-if="clientType === 'g' && getCurrentSubmodule && clientTypeSoftwareCode === softwareCode"
                    icon="iconfont icon-zairu"
                    plain
                    @click="batchLoadComponent"
                >
                  载入
                </el-button>
                <el-button icon="iconfont icon-yidong" plain @click="openClassifyDialog('batch')">移动</el-button>
                <el-button icon="iconfont icon-wenjian-shanchu" class="delete-button" plain @click="batchDelete('deleteSpaceComponent')">删除</el-button>
              </div>
              <div v-else class="batch-button-box">
                <el-tooltip v-if="clientType === 'web'" content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-wenjian-xiazai" /><span>下载</span></span>
                </el-tooltip>
                <el-tooltip v-if="clientType === 'g' && getCurrentSubmodule && clientTypeSoftwareCode === softwareCode" content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-zairu" /><span>载入</span></span>
                </el-tooltip>
                <el-tooltip content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-yidong" /><span>移动</span></span>
                </el-tooltip>
                <el-tooltip content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-wenjian-shanchu" /><span>删除</span></span>
                </el-tooltip>
              </div>
            </div>
            <div class="btn-right">
              <span>共 {{ dataTotal }} 个内容</span>
              <el-button
                type="text"
                icon="el-icon-refresh-right"
                title="刷新"
                class="refresh-btn"
                @click="getList(true, true)"
              />
            </div>
          </template>
          <template #tableBox>
            <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="tableData"
              :has-page="false"
              :sort-map="sortMap"
              @table-selection-change="selectionChange"
              @table-sort-change="sortChange"
              @row-dblclick="rowDblclick"
            >
              <template #imageSlot="{ row }">
                <img v-if="row.status !== 'PROCESSING' && row.thumbnail" :src="$hosts.static(row.thumbnail)" class="thumbnail" @error="handleThumbnailError">
                <img v-else src="@/assets/img/resource-default.png" class="thumbnail">
              </template>
              <template #nameLabelSlot>
                <span>名称</span>
              </template>
              <template #nameSlot="{ row, index }">
                <edit-input
                  v-if="modifyIndex === index && modifyCol === 'name'"
                  ref="editName"
                  :maxlength="30"
                  :init-value="tempRow.name"
                  @edit-confirm="(value)=>modifyName(row, value)"
                  @edit-cancel="resetModify"
                />
                <span v-else>
                  {{ row.name }}
                </span>
              </template>
              <template #categorySlot="{ row }">
                {{ row.spaceCategoryNames && row.spaceCategoryNames.length ? row.spaceCategoryNames.join('>') : '' }}
              </template>
              <template #tagSlot="{ row }">
                <tags-display :tags="row.tags" />
              </template>
              <template #statusLabelSlot>
                <span>状态</span>
              </template>
              <template #statusSlot="{ row }">
                <span v-if="row.status === 'PROCESSING'" class="ft-grey grey statusButton">解析中</span>
                <span v-if="row.status === 'TOBE_RELEASED'" class="ft-green green statusButton">解析成功</span>
                <span v-if="row.status === 'PROCESSED_FAILED'" class="ft-red red statusButton">解析失败</span>
              </template>
              <template #operateSlot="{ row , index}">
                <template>
                  <el-button
                    type="text"
                    title="布置"
                    v-if="clientType !== 'web' && !['AppGbr', 'AppGroad'].includes(clientTypeSoftwareCode) && clientTypeSoftwareCode === softwareCode"
                    :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_PLACE': 'REVIT_COMPONENT_PLACE') || clientTypeSoftwareVersion < row.softwareVersion"
                    @click="toPlace(row)"
                  >
                  <span>布置</span>
                  </el-button>
                  <el-button
                    type="text"
                    title="载入"
                    v-if="clientType === 'g' && clientTypeSoftwareCode === softwareCode"
                    :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_COMPONENT_LOAD') || clientTypeSoftwareVersion < row.softwareVersion"
                    @click="toLoadComponent(row)"
                  >
                  <span>载入</span>
                  </el-button>
                  <el-button
                    type="text"
                    title="详情"
                    :disabled="row.status ==='PROCESSING' || hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_DETAIL': 'REVIT_COMPONENT_DETAIL')"
                    @click="toDetail(row)"
                  >
                  <span>详情</span>
                  </el-button>
                  <el-button
                    type="text"
                    title="更新"
                    :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_UPDATE': 'REVIT_COMPONENT_UPDATE')"
                    @click="onRenewal(row, 'renewal')"
                    v-if="clientType === 'web'"
                  >
                  <span>更新</span>
                  </el-button>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-if="clientType !== 'web'"
                        :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_UPDATE': 'REVIT_COMPONENT_UPDATE')"
                        @click.native="onRenewal(row,'renewal')">更新</el-dropdown-item>
                      <el-dropdown-item :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_RENAME': 'REVIT_COMPONENT_RENAME')" @click.native="cellClick(row,index, 'name')">重命名</el-dropdown-item>
                      <el-dropdown-item v-if="(!getCurrentSubmodule && !hasPermission(row.permissionType, 'REVIT_COMPONENT_DOWNGRADE'))" :disabled="hasPermission(row.permissionType, 'REVIT_COMPONENT_DOWNGRADE')" @click.native="downgrades(row)">降级</el-dropdown-item>
                      <el-tooltip v-else-if="(!getCurrentSubmodule && hasPermission(row.permissionType, 'REVIT_COMPONENT_DOWNGRADE'))" class="item" effect="dark" content="无操作权限" placement="right">
                        <span>
                          <el-dropdown-item disabled>降级</el-dropdown-item>
                        </span>
                      </el-tooltip>
                      <el-dropdown-item :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_MOVE': 'REVIT_COMPONENT_MOVE')" @click.native="openClassifyDialog('single', row)">移动</el-dropdown-item>
                      <el-dropdown-item :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_DOWNLOAD': 'REVIT_COMPONENT_DOWNLOAD')" v-if="clientType === 'web'" @click.native="toDownload(row)">下载</el-dropdown-item>
                      <el-dropdown-item :disabled="hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_DELETE': 'REVIT_COMPONENT_DELETE')" :class="!hasPermission(row.permissionType, getCurrentSubmodule ? 'NOVA_DESIGN_COMPONENT_DELETE': 'REVIT_COMPONENT_DELETE') && 'delete'" @click.native="deleteResources(row)">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </template>
            </gjw-table>
          </template>
          <template #footerBox>
            <uploader
              ref="uploader"
              class="component-uploader"
              :operate='operateType'
              :allow-types="allowFileType(softwareCode)"
              :platform="platformCode"
              :software-code="softwareCode"
              :software-version="softwareVersion"
              :language="language"
              :file-table-columns="uploaderFileTableColumns"
              :space-category-id="spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : rootNode.id"
              :space-classify-tree="spaceClassifyTree"
              :renewal-obj="renewalObj"
              @success="uploadCallback"
              @updateList="updateList" />
            <el-pagination
              class="pagination"
              layout="prev, pager, next, sizes"
              :pager-count="5"
              :total="dataTotal"
              :current-page="pageNo"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100]"
              @current-change="currentChange"
              @size-change="sizeChange" />
          </template>
        </gjw-list-page-layout>
      </div>
    </div>
    <!--移动-->
    <gjw-dialog
      :show-dialog="showClassifyDialog"
      class="ClassifyDialog"
      :title="typeName"
      :confirm-loading="moveLoading"
      @close="closeClassifyDialog"
      @confirm="confirmModifyClassify">
      <classifySelectV2
        ref="classifySelectDialog"
        :tree-data="classifyData.tree"
        :expanded-keys="[rootNode.id]"
        @tree-node-click="chooseBatchClassify"
      />
    </gjw-dialog>
    <component-detail-plugin ref="pluginComponentDetailDrawer" :current-submodule="currentSubmodule" @close="handleClose" @toPlace="toPlace" @toLoad="toLoadComponent"/>
    <select-component-type v-if="clientType !== 'web'" ref="pluginPlaceTypeDialog"></select-component-type>
    <!-- 降级弹框 -->
    <downgrades-dialog ref="downgradesDialogRef" :dialog-visible="downgradesDialogVisible" @close="downgradesDialogVisible = false" @confirm="handleDowngrades"/>
    <!-- 载入重名弹框 -->
    <check-rename-dialog ref="CheckRenameDialogRef" :dialogVisible="checkRenameDialogVisible" :selectedList="selectedList" @confirm="handleConfirmConfirm" @close="checkRenameDialogVisible = false; subdivideType = ''"/>
    <!-- 载入 -->
    <load-progress-bar-dialog v-if="clientType !== 'web'" ref="LoadProgressBarDialogRef" :selectedList="selectedList" @clearSelection="clearSelection"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Dict from '@/core/dict'
import Utils from '@/core/utils'
import { RegSymbol } from '@/core/RegExp'
import PageTitle from '@/components/business/PageTitle.vue'
import EditInput from '@/components/business/EditInput.vue'
import SoftwareSelect from '@/components/business/resource/SoftwareSelect.vue'
import SelectComponentType from '../components/SelectComponentType.vue'
import classifySelectV2 from '@/components/business/resource/classifySelectV2.vue'
import ClassifyTreeV2 from '@/components/business/resource/ClassifyTreeV2.vue'
import Uploader from '@/components/business/resource/Uploader.vue'
import Queue from '@/core/queue'
import { getFileTypes, getSoftwareCodesByPlatformCode } from '@/assets/js/resourceMap.js'
import { downgradesErrorCodeMap } from '../errorCodeMap'
import resourceOperations from '@/mixins/resourceOperations'
import permissionMixin from '@/mixins/permissionMixin.js'
import ComponentDetailPlugin from './ComponentDetailPlugin.vue'
import DowngradesDialog from '../components/DowngradComponentesDialog.vue'
import CheckRenameDialog from '../components/CheckRenameComponentDialog.vue'
import LoadProgressBarDialog from '../components/LoadProgressBarDialog.vue'
import resourceDefault from '@/assets/img/resource-default.png'
import pollingMixin from '@/mixins/pollingMixin'

export default {
  name: 'ComponentList',
  props: {
    prop: {
      type: Object,
    },
    activeName: {
      type: String,
    },
  },
  components: {
    PageTitle,
    SoftwareSelect,
    ClassifyTreeV2,
    EditInput,
    Uploader,
    classifySelectV2,
    ComponentDetailPlugin,
    SelectComponentType,
    DowngradesDialog,
    CheckRenameDialog,
    LoadProgressBarDialog
  },
  mixins: [resourceOperations, permissionMixin, pollingMixin],
  data() {
    return {
      // 是否为首次进入页面
      firstEnter: true,
      // 构件的资源类型
      resourceType: 'COMPONENT',
      language: null,
      currentSubmodule: '',
      platformCode: '',
      softwareCode: '',
      softwareVersion: '',
      searchForm: {},
      statusOpts: Dict.statusOptionsAll,
      tableData: [],
      tableLoading: false,
      sortMap: { createTime: 'CREATE_TIME', updateTime: 'UPDATE_TIME' },
      modifyIndex: -1, // 当前要修改的行序
      modifyCol: '', // 当前要修改的col
      tempRow: {}, // 备份要修改的row
      showClassifyDialog: false,
      batchClassifyValue: '',
      dataTotal: 0,
      pageNo: 1,
      pageSize: 20,
      operateType: 'upload',
      renewalObj: {},
      crQueue: new Queue(5, this.createNewComponent), // 创建队列实例
      reQueue: new Queue(5, this.renewalComponent), // 更新队列实例
      spaceId: this.$route.params.spaceId,
      spaceResourceId: '',
      spaceCategoryIdMove: '',
      typeName: '移动到',
      moveType: '',
      moveLoading: false,
      availableResource: false,
      activePermissionType: '',
      defaultKeyArr: [],
      downgradesDialogVisible: false,
      checkRenameDialogVisible: false,
      subdivideType: ''
    }
  },
  computed: {
    ...mapGetters({
      spacesDetail: 'classifySpace/spacesDetail',
      spacePlatClassify: 'classifySpace/spacePlatClassify',
      spaceClassifyTree: 'classifySpace/spaceClassifyTree',
      getSpaceRootNode: 'classifySpace/getRoot',
      getSpaceTreeAuthWithCount: 'classifySpace/getTreeAuthWithCount',
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      clientType: 'platform',
      isCapitalSoftware: 'isCapitalSoftware',
      user: 'user/user'
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'selection',
          width: '48px',
          selectable: (row) => {
            return !row.upgrading
          },
          attrs: {
            align: 'center',
          },
        },
        {
          type: 'slot',
          slotName: 'imageSlot',
          label: '缩略图',
          prop: 'thumbnail',
          width: '60px',
          fmtUrl: (url) => this.$hosts.static(url),
        },
        {
          type: 'slot',
          slotName: 'nameSlot',
          labelSlotName: 'nameLabelSlot',
          prop: 'name',
          minWidth: '100px',
        },
        {
          type: 'slot',
          slotName: 'categorySlot',
          label: '所属目录',
          prop: 'spaceCategoryNames',
          minWidth: '160px',
        },
        {
          label: '适配版本',
          prop: 'softwareVersionName',
          minWidth: '80px',
        },
        {
          label: '创建时间',
          prop: 'createTime',
          sortable: false,
          minWidth: '118px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新时间',
          prop: 'updateTime',
          sortable: false,
          minWidth: '118px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          type: 'slot',
          slotName: 'statusSlot',
          minWidth: '90px',
          labelSlotName: 'statusLabelSlot',
          prop: 'status'
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          minWidth: this.clientType === 'web' ? '120px' : '140px'
        },
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    uploaderFileTableColumns() {
      return {
        appName: this.platformCode === 'NOVA_DESIGN' || this.platformCode === 'REVIT' || this.softwareCode === 'bimmake', // acs暂不处理
        classify: this.operateType !== 'renewal',
        validation:
          this.platformCode === 'NOVA_DESIGN' || this.platformCode === 'REVIT' || this.softwareCode === 'bimmake',
      }
    },
    uploaderSpaceClassifyId() {
      // 默认的上传至
      // 数维：行业用的映射得到 企业用的用户传入
      // R和通用：行业用的其他 企业用的用户传入
      const spaceCategoryId = this.spaceCategoryId
      return spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : this.rootNode.id
    },
    getCurrentSubmodule () {
      return this.currentSubmodule === 'V_Component_NOVA_DESIGN'
    },
    classifyData() {
      return this.getSpaceTreeAuthWithCount
    },
    rootNode() {
      return this.getSpaceRootNode
    },
  },
  mounted() {
    if (!this.spaceId) { return }
    const query = {
      resource_type: this.resourceType,
      space_id: this.spaceId,
      platform_code: this.platformCode,
    }
    this.getSpacePlatClassify(query)
  },
  created() {
    this.startPolling(this.polling)
  },
  methods: {
    ...mapActions({
      // 获取当前用户有权限的目录列表
      getSpacePlatClassify: 'classifySpace/getSpacePlatClassify',
      getSpacePlatClassifyAgg: 'classifySpace/getSpacePlatClassifyAgg',
      getSpacesDetail: 'classifySpace/getSpacesDetail',
      checkFeedbackExists: 'feedback/checkFeedbackExists',
      // loadSoftwareVersionNameMap: 'resourceCommon/loadSoftwareVersionNameMap',
    }),
    handleThumbnailError(event) {
      event.target.src = resourceDefault
    },
    isAvailableROperation(item) {
      return this.platform === 'r' && item.status === ''
    },
    isAvailableGOperation() {
      return this.platform === 'web'
    },
    moduleChange(subModuleCode) {
      this.currentSubmodule = subModuleCode
      this.platformCode = Utils.splitPlatform(subModuleCode)
      this.softwareCode = getSoftwareCodesByPlatformCode(this.platformCode)
      this.$refs.softwareSelect && this.$refs.softwareSelect.resetSelectedVersion()
      this.resetSelectedClassify()
      this.selectedList = []
      // 切换资源类型后，适配软件一定会切换，所以此处不需要调用search()，但需要清空searchForm。
      this.searchForm = {}
      this.firstEnter = true
    },
    changeSoftware({ software, version }) {
      this.softwareCode = software.softwareCode
      this.softwareVersion = version.softwareVersion
      if (this.firstEnter) {
        this.availableResource = this.clientType !== 'web' && this.clientTypeSoftwareCode === this.softwareCode
      } else {
        this.availableResource = false
      }
      this.search(true, !this.firstEnter)
      this.firstEnter = false
    },
    async filterClassify() {
      try {
        const query = {
          ...this.searchForm,
          resource_type: this.resourceType,
          space_id: this.spaceId,
          software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
          software_version: this.availableResource ? null : this.softwareVersion,
          software_platform: this.platformCode,
          native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
          available_resources: this.availableResource || null
        }
        if (this.availableResource) {
          query.status = null
        }
        await this.getSpacePlatClassifyAgg(query)
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },
    treeNodeClick(node) {
      this.activePermissionType = node.permissionType
      this.resetSelectedClassify()
      this.spaceCategoryId = node.id
      !this.defaultKeyArr.includes(node.id) && this.defaultKeyArr.push(node.id)
      this.$refs.classifyTree?.highlightSomeNode(this.spaceCategoryId)
      this.search(false)
    },
    treeNodeExpand(node) {
      this.treeNodeClick(node)
    },
    treeNodeCollapse(node) {
      if (this.defaultKeyArr.includes(node.id)) {
        this.defaultKeyArr = this.defaultKeyArr.filter((item) => item !== node.id)
      }
    },
    checkDuplicateNames() {
      const seenNames = new Set()
      for (const item of this.selectedList) {
        if (seenNames.has(item.name)) {
          return true
        }
        seenNames.add(item.name)
      }
      return false
    },
    async batchLoadComponent() {
      // 资源批量载入，弹框评分
      this.checkFeedbackExists()
      const hasDuplicates = this.checkDuplicateNames.call(this.selectedList)
      if (hasDuplicates) {
        this.$message.error('当前所选的构件中包含同名构件，不支持批量载入！')
        return
      }
      this.subdivideType = 'batch'
      const operationKey = await this.getOperationKey('id')
      const batchSelectData = await this.$api.resource.batchDownload(this.spaceId, operationKey)
      await this.toLoadComponent({}, 'batch', batchSelectData)
    },
    // 打开弹框
    async openClassifyDialog(moveType, row) {
      this.moveType = moveType
      if (row && row.spaceResourceId) {
        await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
        this.typeName = '移动 ' + row.name + ' 到'
        // 获取当前选中ID
        this.spaceResourceId = row.spaceResourceId
      } else {
        this.typeName = '移动到'
      }
      this.showClassifyDialog = true
    },
    // 关闭弹框
    closeClassifyDialog() {
      this.showClassifyDialog = false
      this.batchClassifyValue = ''
      this.moveLoading = false
    },
    // 目标节点选取
    chooseBatchClassify(value) {
      this.spaceCategoryIdMove = value.id
      this.batchClassifyValue = value.id
    },
    // 移动
    confirmModifyClassify() {
      this.moveLoading = true
      // 批量移动
      if (this.moveType === 'batch') {
        this.batchUpdateClassify(this.batchClassifyValue)
      } else {
        const params = {
          spaceResourceId: this.spaceResourceId,
          spaceCategoryId: this.spaceCategoryIdMove,
        }
        this.$api.resource.spaceCategory(this.spaceId, params).then(() => {
          this.$message.success(`移动成功`)
          this.$tracks({
            event: 'moveSpaceComponent',
            params: { g_c_space_id: this.spaceId, }
          })
          this.search(true, false)
          this.closeClassifyDialog()
        }).catch((err) => {
          this.moveLoading = false
          const errors = {
            'space.resource.name.duplicate': '目标文件夹下存在重名资源',
            'space.resource.update.category.empty.error': '移动失败',
          }
          this.$matchError(err.code, errors, '移动失败')
        })
      }
    },
    // 删除
    async deleteResources(row) {
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.$confirm(`是否确定删除 <b>${row.name}.${row.suffix}</b>？`, {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'user-confirm',
        confirmButtonText: '确定删除',
      })
        .then(() => {
          this.$api.resource.deleteSpaceResources(this.spaceId, row.id).then(() => {
            this.$message.success(`删除成功`)
            this.$tracks({
              event: 'deleteSpaceComponent',
              params: { g_c_space_id: this.spaceId, }
            })
            this.search(true, false)
          }).catch((err) => {
            const errors = {
              'resource.exist': '请将节点下的内容移除后再试。',
              'space.resource.delete.error': '删除失败',
            }
            this.$matchError(err.code, errors, '删除失败')
          })
        })
        .catch(() => { })
    },
    // 下载
    toDownload(item) {
      if (item.downloadLoading) {
        return false
      }
      // 资源下载，弹框评分
      this.checkFeedbackExists()
      this.$api.resource
        .getDownloadUrl(this.spaceId, item.spaceResourceId, item.id, item.dataVersionId)
        .then((res) => {
          this.$downloadFile(res)
          this.$tracks({
            event: 'downloadSpaceComponent',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: item.spaceResourceId,
            }
          })
        })
        .finally((e) => {
          item.downloadLoading = false
        })
    },
    updateListData(value) {
      if (value === 'permission') {
        this.$tracks({ event: 'modifyResourceFolderPermission', params: { g_c_space_id: this.spaceId }})
      } else if (value === 'deleteNode') {
        this.$tracks({ event: 'deleteResourceFolder', params: { g_c_space_id: this.spaceId }})
      }
      this.search(true, false)
    },
    handleDrop() {
      this.search(true, false)
    },
    handleRename() {
      this.$tracks({ event: 'renameResourceFolder', params: { g_c_space_id: this.spaceId }})
      this.search(true, false)
    },
    handleNew() {
      this.$tracks({ event: 'newResourceFolder', params: { g_c_space_id: this.spaceId }})
      this.search(true, false)
    },
    resetSelectedClassify() {
      this.softwareCategoryCode = null
      this.spaceCategoryId = null
    },
    sortChange(sortObj) {
      this.searchOrder = { ...sortObj }
      this.search()
    },
    rowDblclick(row) {
      this.toDetail(row)
    },
    async changeAvailableResource() {
      await this.search()
    },
    async search(refreshClassify = true, isTrack = true) {
      this.pageNo = 1
      await this.getList(refreshClassify, isTrack)
    },
    /**
     * @params refreshClassify：是否刷新分类树数据；
     * @params isTrack：是否触发埋点(纯列表数据刷新时，不埋点，只有当用户触发搜索search时，进行埋点)
     * */
    async getList(refreshClassify = true, isTrack = false) {
      // 更新数据时，取消编辑状态
      this.resetModify()
      const query = {
        ...this.searchForm,
        page_no: this.pageNo,
        page_size: this.pageSize,
        space_id: this.spaceId,
        resource_type: this.resourceType,
        software_platform: this.platformCode,
        software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
        software_version: this.availableResource ? null : this.softwareVersion,
        space_category_id: this.spaceCategoryId,
        native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
        available_resources: this.availableResource || null
      }
      if (this.availableResource) {
        query.status = null
      }
      this.tableLoading = true
      if (refreshClassify) {
        const query = {
          resource_type: this.resourceType,
          space_id: this.spaceId,
          platform_code: this.platformCode,
        }
        await this.getSpacePlatClassify(query).catch()
        this.filterClassify({ ...query }).then(() => {
          // 选中节点高亮并展开
          const id = this.spaceCategoryId
          const key = id || id === 0 ? id : this.rootNode.id
          this.$nextTick(() => {
            this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(key)
            !this.defaultKeyArr.includes(this.classifyData.tree[0]?.id) && this.defaultKeyArr.push(this.classifyData.tree[0]?.id)
            this.activePermissionType = this.classifyData.tree[0].permissionType
          })
        })
      }
      this.$api.resource
        .getSpaceResources(this.spaceId, query)
        .then((data) => {
          this.tableData = data.list || []
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.permissionType = (this.spacePlatClassify.find((f) => f.id === item.spaceCategoryId) || {}).permissionType
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
          if (isTrack) {
            this.$tracks({
              event: 'querySpaceComponent',
              params: {
                g_c_space_id: this.spaceId,
                g_c_keyword: query.keyword,
                g_c_folder_id: query.space_category_id,
                g_c_condition: query,
                g_c_result_count: data.totalCount
              }
            })
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    // 轮询获取列表
    async getListForPolling() {
      const query = {
        ...this.searchForm,
        page_no: this.pageNo,
        page_size: this.pageSize,
        space_id: this.spaceId,
        resource_type: this.resourceType,
        software_platform: this.platformCode,
        software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
        software_version: this.availableResource ? null : this.softwareVersion,
        space_category_id: this.spaceCategoryId,
        native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
        available_resources: this.availableResource || null
      }
      if (this.availableResource) {
        query.status = null
      }

      const queryClassify = {
        resource_type: this.resourceType,
        space_id: this.spaceId,
        platform_code: this.platformCode,
      }
      this.filterClassify({ ...queryClassify }).then(() => {
        // 选中节点高亮
        const id = this.spaceCategoryId
        const key = id || id === 0 ? id : this.rootNode.id
        this.$nextTick(() => {
          this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(key)
          this.activePermissionType = this.classifyData.tree[0].permissionType
        })
      })

      this.$api.resource
        .getSpaceResources(this.spaceId, query)
        .then((data) => {
          this.tableData = data.list || []
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.permissionType = (this.spacePlatClassify.find((f) => f.id === item.spaceCategoryId) || {}).permissionType
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
        })
    },
    // 判断行数据是否可单个编辑
    canEdit(row) {
      return (
        // !row.upgrading && row.status !== 'PROCESSING' && row.status !== 'PROCESSED_FAILED'
        !row.upgrading
      )
    },
    // 修改之后重置
    resetModify() {
      this.startPolling(this.polling)
      this.modifyCol = ''
      this.modifyIndex = -1
      this.tempRow = {}
    },
    // 修改名称
    async modifyName(row, value) {
      if (row.name === value) {
        this.resetModify()
        return
      }
      if (RegSymbol.test(value)) {
        this.$message.error('名称中有禁止的特殊符号')
        return
      }
      await this.$api.resource.updateName(this.spaceId, row.spaceResourceId, { name: value }).then(() => {
        this.$message.success(`修改成功`)
        this.$tracks({
          event: 'renameSpaceComponent',
          params: { g_c_space_id: this.spaceId, }
        })
        this.resetModify()
        this.getList(true, false)
      }).catch((err) => {
        const errors = {
          'resource.not.exist': '资源不存在',
          'resource.name.contain.special.characters': '名称中有禁止的特殊符号',
          'resource.name.already.existed': '资源名称已存在',
          'name.length.exceed': '资源名称查出限制',
        }
        this.$matchError(err.code, errors, '修改失败')
      })
    },
    downgrades(row) {
      // 资源降级，弹框评分
      this.checkFeedbackExists()
      if (row.softwareVersion <= 2016 || row.softwareVersion >= 2023) {
        this.$message.error('仅支持降级软件版本在2017~2022之间的构件')
        return
      }
      this.downgradesDialogVisible = true
      this.$refs.downgradesDialogRef?.init(row)
    },
    async handleDowngrades(row, targetSoftwareVersion) {
      try {
        const res = await this.$api.resource.downgrades(this.spaceId, { spaceResourceId: row.spaceResourceId, targetVersion: targetSoftwareVersion, version: row.softwareVersion })
        this.downgradesDialogVisible = false
        this.$refs.uploader.showUploadList('downgrades', res)
        this.$tracks({
          event: 'downGradeComponent',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: row.spaceResourceId,
            g_c_file_version_down: targetSoftwareVersion
          }
        })
      } catch (err) {
        this.$matchError(err.code, downgradesErrorCodeMap, '降级失败')
      }
    },
    handleConfirmConfirm(data, row, actionType, subdivideType, batchSelectData) {
      switch (actionType) {
        case 'place':
          data.forEach((item) => {
            this.$refs.pluginPlaceTypeDialog?.openDialog(this.spaceId, row, true, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
          })
          break
        case 'load':
          if (subdivideType === 'single') {
            data.forEach((item) => {
              this.$refs.LoadProgressBarDialogRef?.openDialog(this.spaceId, row, subdivideType, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
            })
          } else if (subdivideType === 'batch') {
            this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(this.spaceId, subdivideType, data, batchSelectData)
          }
          break
      }
    },
    clearSelection() {
      this.$refs.listTable.$children[0]?.clearSelection()
    },
    // 点击构件名称 单元格时触发
    async cellClick(row, index, colName) {
      this.stopPolling()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      if (!this.canEdit(row)) {
        return
      }
      this.modifyCol = colName
      this.modifyIndex = index
      this.tempRow = { ...row }
      this.$nextTick(() => {
        switch (colName) {
          case 'name':
            this.$refs.editName.toFocus()
            break
        }
      })
    },
    // 点击上传
    async showUploader(operateType) {
      // 资源上传，弹框评分
      this.checkFeedbackExists()
      await this.$api.resource.hasResources(this.spaceId, this.spaceCategoryId)
      this.operateType = operateType
      this.$refs.uploader.showModal(operateType)
    },
    async onRenewal(row, operateType) {
      // 资源更新，弹框评分
      this.checkFeedbackExists()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.operateType = operateType
      this.renewalObj = row
      this.renewalObj.spaceId = this.spaceId
      this.$refs.uploader.showModal(operateType)
    },
    allowFileType(softwareCode) {
      if (softwareCode) {
        const types = getFileTypes('COMPONENT', softwareCode) || []
        return types.join(',')
      }
    },
    // 秒传/上传后的回调
    uploadCallback({ file, id }) {
      this.$refs.uploader.updateFile(file, { uploadProgress: 100 })
      if (file.operate === 'upload') {
        this.crQueue.preDo({ file, id })
      } else {
        // 替换
        this.reQueue.preDo({ file, id })
      }
    },
    updateList() {
      this.getList()
    },
    // 创建新构件
    createNewComponent({ file, id }) {
      const params = {
        brandCode: file.brandCode,
        md5: file.md5,
        name: file.name,
        language: file.language,
        originalSoftwareVersion: file.appVersion, // 资源解析出来的或者没有
        resourceType: 'COMPONENT',
        softwareCategoryCode: file.categoryCode, // 解析到软件分类编码
        softwareCode: file.softwareCode,
        spaceCategoryId: file.spaceCategoryId,
        storeId: id,
        tagIds: file.tagIds,
        targetSoftwareVersion: null, // 需要升级的资源是当前选中的软件版本，其余设置为空
      }
      this.$api.resource.createResource(this.spaceId, params).then((res) => {
        // 根据接口返回增加一种字段 更新成功 updateSuccess
        if (res && res.creationPolicy === 'NEW') {
          this.$tracks({
            event: 'uploadSpaceComponent',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: res.id,
              g_c_file_format: res.suffix
            }
          })
          const uploadStatus = 'success'
          this.$refs.uploader.updateFile(file, { uploadStatus, uploadProgress: 100 })
          this.$refs.softwareSelect && this.$refs.softwareSelect.softwareChange()
        } else {
          let uploadStatus = 'fail'
          if (['resource.name.already.existed', 'resource.md5.already.existed'].includes(res.code)) {
            uploadStatus = 'existed'
          }
          this.$refs.uploader.updateFile(file, { uploadStatus: uploadStatus })
        }
      }).catch((err) => {
        let uploadStatus = 'fail'
        if (['resource.name.already.existed', 'resource.md5.already.existed'].includes(err.code)) {
          uploadStatus = 'existed'
        }
        this.$refs.uploader.updateFile(file, { uploadStatus: uploadStatus })
      }).finally(() => {
        this.crQueue.nextDo()
      })
    },
    // 更新构件
    renewalComponent({ file, id }) {
      const params = {
        softwareCode: file.softwareCode,
        softwareVersion: file.softwareVersion,
        language: file.language,
        name: file.name,
        md5: file.md5,
        resourceType: 'COMPONENT',
        storeId: id,
      }
      this.$api.resource.renewalResource(this.spaceId, file.spaceResourceId, file.softwareVersionId, params).then(() => {
        this.$tracks({
          event: 'updateSpaceComponent',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: file.spaceResourceId,
          }
        })
        this.$refs.uploader.updateFile(file, { uploadStatus: 'success', uploadProgress: 100 })
        this.search(true, false)
      }).catch((err) => {
        if (err.code === 'resource.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'md5Duplicate' })
        } else if (err.code === 'resource.mismatch') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'versionMismatch' })
        } else if (err.code === 'space.resource.software.version.not.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'notExisted' })
        } else {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'fail' })
        }
      }).finally(() => {
        this.reQueue.nextDo()
      })
    },
    async toDetail(row) {
      // 资源详情，弹框评分
      this.checkFeedbackExists()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      if (row.status === 'PROCESSING') return
      const detail = this.$router.resolve({
        name: 'ComponentDetail',
        params: { spaceId: this.spaceId, componentId: row.spaceResourceId },
        query: {
          softwareCode: row.softwareCode,
          softwareVersion: row.softwareVersion,
          currentSubmodule: this.currentSubmodule
        },
      })
      if (this.clientType === 'web') {
        window.open(`${detail.href}&title=${row.name}`, '_blank')
      } else {
        this.$refs.pluginComponentDetailDrawer && this.$refs.pluginComponentDetailDrawer.openDrawer(this.spaceId, row)
      }
    },
    handleClose(isChangedDataVersion) {
      this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(this.spaceCategoryId)
      if (isChangedDataVersion) {
        this.search(true, false)
      }
    },
    async toLoadComponent(row, subdivideType = 'single', batchSelectData) {
      // 资源载入，弹框评分
      this.checkFeedbackExists()
      subdivideType === 'single' && await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      if (this.isCapitalSoftware) {
        if (subdivideType === 'single') {
          this.$refs.LoadProgressBarDialogRef?.openDialog(this.spaceId, row, subdivideType).catch()
        } else if (subdivideType === 'batch') {
          this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(this.spaceId, subdivideType, this.selectedList, batchSelectData).catch()
        }
      } else {
        const componentNames = this.selectedList.length && subdivideType === 'batch' ? this.selectedList.map((item) => item.name) : [row.name]
        const result = await this.$desktopClient.ListComponentsByNames(componentNames)
        if (result.code === 'success') {
          const updatedDataList = result.data
          if (updatedDataList.length) {
            this.checkRenameDialogVisible = true
            this.$refs.CheckRenameDialogRef?.init(updatedDataList, row, 'load', subdivideType, batchSelectData)
          } else {
            if (subdivideType === 'single') {
              this.$refs.LoadProgressBarDialogRef?.openDialog(this.spaceId, row, subdivideType).catch()
            } else if (subdivideType === 'batch') {
              this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(this.spaceId, subdivideType, this.selectedList, batchSelectData).catch()
            }
          }
        }
      }
    },
    async toPlace(row) {
      // 资源布置，弹框评分
      this.checkFeedbackExists()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      if (this.clientType === 'r') {
        await this.$refs.pluginPlaceTypeDialog?.openDialog(this.spaceId, row)
      } else if (this.clientType === 'g') {
        const componentNames = this.selectedList.length && this.subdivideType === 'batch' ? this.selectedList.map((item) => item.name) : [row.name]
        const result = await this.$desktopClient.ListComponentsByNames(componentNames)
        if (result.code === 'success') {
          const updatedDataList = result.data
          if (updatedDataList.length) {
            this.checkRenameDialogVisible = true
            this.$refs.CheckRenameDialogRef?.init(updatedDataList, row, 'place')
          } else {
            await this.$refs.pluginPlaceTypeDialog?.openDialog(this.spaceId, row)
          }
        }
      }
    },
    // 分页
    currentChange(val) {
      this.pageNo = val
      this.getList(false)
    },
    sizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getList(false)
    },
    async polling() {
      await this.getListForPolling()
    },
  },
}
</script>

<style lang="less" scoped>
.flex-1 {
  height: calc(100vh - 136px);
}

.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 16px;
}
.batch-button-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
/deep/.el-table__header {
  background-color: grey;
}

/deep/.el-dropdown {
  color: #009ee1;
}

.delete {
  color: red;
}

.delete:hover {
  color: #fff;
  background: red;
}

.el-dropdown-menu {
  width: 70px;
  // height: 112px;
  border-radius: 2px;
  padding: 4px 0px;
  text-align: center;
}

.statusButton {
  padding: 1px 5px;
  border-radius: 2px;
}

.green {
  background: #fafafa;
  border: 1px solid #b7eb8f;
}

.grey {
  background: @bg-grey-light-2;
  border: 1px solid @border-color-tag;
}

.red {
  background: #fff1f0;
  border: 1px solid #ffa39e;
}

.el-tree {
  margin-left: 2px;
}

.btn-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  /deep/ .el-button-group {
    line-height: unset;
  }

  .el-button {
    margin-right: 4px;
  }

  .operations-left {
    margin-right: 12px;
  }
}

.keyword-input {
  width: 200px;
}

.btn-right {
  color: rgba(73, 95, 112, 0.6);
  font-size: 12px;
}

.component-uploader {
  position: fixed;
    bottom: 0;
    z-index: 999;
}

.thumbnail {
  width: 40px;
  height: 40px;
}

.catalog {
  max-height: calc(100vh - 138px);
}

.delete-button:hover,
.delete-button:focus,
.delete-button:active {
  background: #fff;
  border-color: red;
  color: red;
}
/deep/ .right-part {
  width: 1px;
  height: calc(100vh - 145px);
}

/deep/ .el-table .el-table__body-wrapper {
  max-height: calc(100% - 41px);
}

/deep/ .el-table__row {
  cursor: pointer;
}

/deep/ .el-dropdown-link {
    display: inline-block;
    font-size: 12px;
    border-radius: 2px;
    width: 20px;
    height: 20px;
    text-align: center;
  }

/deep/ .el-dropdown-link:hover {
  background: #FFFFFF;
}
</style>
<style>
.el-switch .el-switch__label{
  font-weight: normal;
  color:#495F70
}
.el-switch__label.is-active{
  color:#495F70
}
.el-message-box .el-message-box__btns .user-confirm {
  color: #ff4d4f;
  width: 88px;
  height: 32px;
  border: 1px solid #ff4d4f;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.016);
}
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
  background: #DAE0E8;
}
.available-switch .el-switch__label * {
  font-size: 12px;
}
.status-select .el-input {
  font-size: 12px;
}
</style>
